class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        this.checkActiveFilters();

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector('form');
        // Removed auto-submit on input - filters now only submit when Apply button is clicked
        // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        // Desktop sort dropdown should still auto-submit (mobile sort is combined with filters and uses Apply button)
        const sortSelect = this.querySelector('#SortBy');
        if (sortSelect) {
            sortSelect.addEventListener('change', this.debouncedOnSubmit.bind(this));
        }

        // Expand filter category when a checkbox is checked
        if (facetForm) {
            facetForm.addEventListener('change', (event) => {
                if (event.target.type === 'checkbox') {
                    const filterContainer = event.target.closest('.js-filter');
                    if (filterContainer) {
                        const collapseElement = filterContainer.querySelector('.collapse');
                        const button = filterContainer.querySelector('.js-facets-summary');
                        if (collapseElement && button && event.target.checked) {
                            // Expand the filter if checkbox is checked
                            collapseElement.classList.add('show');
                            button.setAttribute('aria-expanded', 'true');
                            button.classList.remove('collapsed');
                        }
                    }
                }
            });
        }

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        }
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        // const countContainer = document.getElementById('ProductCount');
        // const countContainerDesktop = document.getElementById('ProductCountDesktop');
        // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        // if (countContainer) {
        //     countContainer.classList.add('loading');
        // }
        // if (countContainerDesktop) {
        //     countContainerDesktop.classList.add('loading');
        // }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = element => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl) ?
                FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
                FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        const loader = document.querySelector('.js-catalog-filter');
        if (loader) window.Global.showLoader(loader);
        this.checkColors();

        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {html, url}];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                // FacetFiltersForm.renderProductCount(html);

            })
            .finally(() => {
                if (loader) window.Global.hideLoader(loader);
                this.checkColors();
            });
    }

    static checkColors() {
        const filter_colors = document.querySelector('.js-filter-colors');
        const filter_color_item = document.querySelectorAll('.js-filter-colors li');
        if (filter_colors) {
            if (!filter_color_item.length > 0) {
                filter_colors.classList.add('hidden');
            } else filter_colors.classList.remove('hidden');
        }
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    }

    // static renderProductCount(html) {
    //     const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    //     const container = document.getElementById('ProductCount');
    //     const containerDesktop = document.getElementById('ProductCountDesktop');
    //     container.innerHTML = count;
    //     if (containerDesktop) {
    //         containerDesktop.innerHTML = count;
    //     }
    // }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements =
            parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        // Save collapse state before re-rendering
        const collapseStates = new Map();
        facetsToRender.forEach((element) => {
            const index = element.dataset.index;
            const existingFilter = document.querySelector(`.js-filter[data-index="${index}"]`);
            if (existingFilter) {
                const collapseElement = existingFilter.querySelector('.collapse');
                const button = existingFilter.querySelector('.js-facets-summary');
                if (collapseElement && button) {
                    const isExpanded = collapseElement.classList.contains('show');
                    const hasActiveValues = existingFilter.querySelector('input[type="checkbox"]:checked') !== null;
                    collapseStates.set(index, {
                        isExpanded: isExpanded || hasActiveValues, // Keep open if has active values
                        button: button
                    });
                }
            }
        });

        // Re-render filters
        facetsToRender.forEach((element) => {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        // Restore collapse state after re-rendering
        collapseStates.forEach((state, index) => {
            const filter = document.querySelector(`.js-filter[data-index="${index}"]`);
            if (filter) {
                const collapseElement = filter.querySelector('.collapse');
                const button = filter.querySelector('.js-facets-summary');
                const hasActiveValues = filter.querySelector('input[type="checkbox"]:checked') !== null;

                if (collapseElement && button) {
                    // If filter has active values, always keep it open
                    if (hasActiveValues) {
                        collapseElement.classList.add('show');
                        button.setAttribute('aria-expanded', 'true');
                        button.classList.remove('collapsed');
                    } else if (state.isExpanded) {
                        // Restore previous expanded state
                        collapseElement.classList.add('show');
                        button.setAttribute('aria-expanded', 'true');
                        button.classList.remove('collapsed');
                    } else {
                        // Keep collapsed
                        collapseElement.classList.remove('show');
                        button.setAttribute('aria-expanded', 'false');
                        button.classList.add('collapsed');
                    }
                }
            }
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        // FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        })

        FacetFiltersForm.toggleActiveFacets(false);
    }

    // static renderAdditionalElements(html) {
    //     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    //
    //     mobileElementSelectors.forEach((selector) => {
    //         if (!html.querySelector(selector)) return;
    //         document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    //     });
    //
    //     document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    // }

    static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
            target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            }
        ]
    }

    checkActiveFilters() {
        const jsActiveFilters = document.querySelector('.js-active-filters');
        if (jsActiveFilters.querySelectorAll('facet-remove').length <= 1) {
            jsActiveFilters.classList.add('hidden');
        } else jsActiveFilters.classList.remove('hidden');
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'))
            this.onSubmitForm(searchParams, event)
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === 'FacetFiltersFormMobile') {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join('&'), event)
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input')
            .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        if (!facetLink) return;

        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        const facetLink = event.currentTarget;
        const href = facetLink.href;

        // Check if this is the "clear all" button by checking if it's in the footer
        // or if the URL has no filter parameters (just base collection URL)
        const isInFooter = this.closest('footer') !== null;
        const url = new URL(href, window.location.origin);
        const searchParams = url.searchParams;

        // Check if URL has any filter parameters (not just sort_by)
        const hasFilterParams = Array.from(searchParams.keys()).some(key =>
            key !== 'sort_by' && key !== 'q' && key !== 'options[prefix]'
        );

        // If it's "clear all" (in footer or no filter params), navigate directly for full page reload
        if (isInFooter || !hasFilterParams) {
            // Allow normal navigation - don't prevent default
            window.location.href = href;
            return;
        }

        // Otherwise, use AJAX for individual filter removal
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        if (form) {
            form.onActiveFilterClick(event);
        }
    }
}

customElements.define('facet-remove', FacetRemove);
